import React, { useState, useEffect } from 'react';
import { formatMoneda } from '../../../util/varios';
import useTableFijo from "../../useTableFijo"
import moment from 'moment';
import axios from "axios";
import { Dimmer } from '../../spinner';
import { InfoButton } from '../../../ui/buttons/Button';
import { Radio } from '../../../ui/inputs/Input';
const TablaDeudaComercio = props => {
    let token = localStorage.getItem("jwtToken");
    let op = require('../../../../src/modulos/datos');
    const fechaSistema = JSON.parse(localStorage.getItem("fechasistema"));
    const espiritu = JSON.parse(localStorage.getItem("espiritu"));
    const [activate, setActivate] = useState(false);
    const [deuda, setDeuda] = useState();
    const [interes, setInteres] = useState();
    const [recargo, setRecargo] = useState();
    const [multa, setMulta] = useState();
    const [totDeuda, setTotDeuda] = useState();
    const [records, setRecords] = useState([]);
    const [moneda, setMoneda] = useState(1);
    const [filterFn] = useState({ fn: items => { return items; } });
    const headCells = [
        { id: 'anio', label: 'AÑO', width: '10px', textAlign: "center", backgroundColor: "rgba(5, 81, 130, 1)", fontSize: "10px", color: "white" },
        { id: 'mes', label: 'MES', width: '80px', textAlign: "center", backgroundColor: "rgba(5, 81, 130, 1)", fontSize: "10px", color: "white" },
        { id: 'mondeu', label: 'MONTO', width: '150px', textAlign: "center", backgroundColor: "rgba(5, 81, 130, 1)", fontSize: "10px", color: "white" },
        { id: 'intmoradeu', label: 'INTERES MORA', width: '150px', textAlign: "center", backgroundColor: "rgba(5, 81, 130, 1)", fontSize: "10px", color: "white" },
        { id: 'multa', label: 'MULTAS', width: '150px', textAlign: "center", backgroundColor: "rgba(5, 81, 130, 1)", fontSize: "10px", color: "white" },
        { id: 'recargodeu', label: 'RECARGOS', width: '150px', textAlign: "center", backgroundColor: "rgba(5, 81, 130, 1)", fontSize: "10px", color: "white" },
    ];
    let heightTabla = 320;
    const {
        TblContainer,
        TblHead,
    } = useTableFijo(records, headCells, filterFn, heightTabla);
    useEffect(() => {
        if (props.tabdeuda) {
            let deu = parseFloat(0.00);
            let inte = parseFloat(0.00);
            let reca = parseFloat(0.00);
            let mul = parseFloat(0.00);
            for (let i = 0; i < props.tabdeuda.length; i++) {
                deu = deu + parseFloat(props.tabdeuda[i].monto);
                inte = inte + parseFloat(props.tabdeuda[i].intereses);
                reca = reca + parseFloat(props.tabdeuda[i].recargo);
                mul = mul + parseFloat(props.tabdeuda[i].multa);
            }
            setDeuda(formatMoneda(deu.toString().replace('.', ','), ',', '.', 2));
            setInteres(formatMoneda(inte.toString().replace('.', ','), ',', '.', 2));
            setRecargo(formatMoneda(reca.toString().replace('.', ','), ',', '.', 2));
            setMulta(formatMoneda(mul.toString().replace('.', ','), ',', '.', 2));
            setTotDeuda(formatMoneda((deu + inte + reca + mul).toString().replace('.', ','), ',', '.', 2));
            setRecords(props.tabdeuda);
        }
    }, [props.tabdeuda]);

    const imprimirDeudaGeneral = () => {
        var reporte = 'EdoCtaCorto2Com';
        var idcomercio = props.idcomercio;
        let fechasistema = JSON.parse(localStorage.getItem('fechasistema'));
        let espiritu = JSON.parse(localStorage.getItem('espiritu'));
        window.open(op.reportes + "/actividadeconomica?" + "reporte=" + reporte + "&id=" + idcomercio + "&fecha=" + `${moment.utc(fechasistema).format('YYYY-MM-DD')}` + "&espiritu=" + espiritu + "&CONDICION=" + moneda, "Planilla", "fullscreen=no,scrollbars=yes,toolbar=no,resizable=no,width=850,height=700");
    }

    const SelectDeudaC = (idcomercio, fecha, espiritu, uni) => {
         const endpoint =
        espiritu === 0
          ? `${op.conexion}/api/industria/deudacomerciors?idcomercio=${idcomercio}&fecha=${fecha}&espiritu=${espiritu}&tipounid=${uni}`
          : `${op.conexion}/api/industria/deudacomercio?idcomercio=${idcomercio}&fecha=${fecha}&espiritu=${espiritu}&tipounid=${uni}`;
        // let endpoint = `${op.conexion}/api/industria/deudacomercio?idcomercio=${idcomercio}&fecha=${fecha}&espiritu=${espiritu}&tipounid=${uni}`;
        setActivate(true)
        axios
            .get(endpoint, {
                headers: {
                    "x-access-token": `${token}`,
                },
            })
            .then(function (response) {
                if (response.status == 200) {
                    var deu = [];
                    var his = [];
                    for (let i = 0; i < response.data.length; i++) {
                        if (response.data[i].fechapago === null) {
                            deu.push({
                                anio: response.data[i].anio,
                                mes: response.data[i].mes.replace("'", "").replace("'", ""),
                                monto: response.data[i].mondeu,
                                intereses: response.data[i].intmoradeu,
                                recargo: response.data[i].recargodeu,
                                multa: response.data[i].multa,
                                retenciones: response.data[i].retencion,
                                credito: response.data[i].acreditacion,
                                totalperi: response.data[i].subtotal,
                                status: response.data[i].estatus,
                                idfac: response.data[i].idfact,
                                nummes: response.data[i].nmes,
                                estatusfac: response.data[i].estatusfac,
                                tipotransaccion: response.data[i].tipotransaccion,
                            });
                        } else {
                            his.push({
                                anio: response.data[i].anio,
                                mes: response.data[i].mes.replace("'", "").replace("'", ""),
                                monto: response.data[i].mondeu,
                                intereses: response.data[i].intmoradeu,
                                recargo: response.data[i].recargodeu,
                                multa: response.data[i].multa,
                                descuento: response.data[i].mondescue,
                                recibo: response.data[i].numreci,
                                fechapago: response.data[i].fechapago,
                                status: response.data[i].estatus,
                                idfac: response.data[i].idfact,
                                estatusfac: response.data[i].estatusfac,
                                tipotransaccion: response.data[i].tipotransaccion,
                            });
                        }
                    }
                    if (deu) {
                        let deud = parseFloat(0.00);
                        let inte = parseFloat(0.00);
                        let reca = parseFloat(0.00);
                        let mul = parseFloat(0.00);
                        for (let i = 0; i < deu.length; i++) {
                            deud = deud + parseFloat(deu[i].monto);
                            inte = inte + parseFloat(deu[i].intereses);
                            reca = reca + parseFloat(deu[i].recargo);
                            mul = mul + parseFloat(deu[i].multa);
                        }
            
                        setDeuda(formatMoneda(deud.toString().replace('.', ','), ',', '.', 2));
                        setInteres(formatMoneda(inte.toString().replace('.', ','), ',', '.', 2));
                        setRecargo(formatMoneda(reca.toString().replace('.', ','), ',', '.', 2));
                        setMulta(formatMoneda(mul.toString().replace('.', ','), ',', '.', 2));
                        setTotDeuda(formatMoneda((deud + inte + reca + mul).toString().replace('.', ','), ',', '.', 2));
                    } 
                    setRecords(deu)
                setActivate(false)
                }
            })
            .catch(function (error) {
                setActivate(false);
            });
    };

    const renderDeuda = (e) => {
        const { value } = e.target
        setMoneda(value)
        SelectDeudaC(props.idcomercio, fechaSistema, espiritu,value )
    }

    return (
        <div className="col-12 m-0 p-0">
            <div className='col-12 m-0 my-2 p-0 d-flex justify-content-between '>
                <div className='col-auto m-0 p-0 d-flex gap-2 align-items-center'>
                    <div class="col-auto m-0 p-0">
                        <Radio 
                            label = 'Monto en Bs.' 
                            onChange={renderDeuda} 
                            value={1}
                            name = 'monto'
                            id = 'montoBs' 
                            
                            defaultChecked
                        />
                    </div>
                    <div class="col-auto m-0 p-0">
                        <Radio 
                            label = 'Monto en U.C' 
                            onChange={renderDeuda} 
                            value={0}
                            name = 'monto'
                            id = 'montUc'  
                        />
                    </div>
                </div>
                <InfoButton icon = 'fa-print m-0'
                    onClick={imprimirDeudaGeneral}
                />
            </div>
            <div className="col-12 m-0 p-0">
                <TblContainer container={{ height: 250, width: '100%', overflow: 'auto', padding: '2px' }} >

                    <TblHead />

                    <tbody>
                        {

                            records && records.map((item, index) => (
                                <tr key={item.anio + item.mes} style={{ padding: "0" }}>
                                    <td style={{ fontSize: "10px", textAlign: "left" }}>{item.anio}</td>
                                    <td style={{ fontSize: "10px", textAlign: "left" }}>{item.mes}</td>
                                    <td style={{ fontSize: "10px", textAlign: "right" }}>{formatMoneda(item.monto.toString().replace('.', ','), ',', '.', 2)}</td>
                                    <td style={{ fontSize: "10px", textAlign: "right" }}>{formatMoneda(item.intereses.toString().replace('.', ','), ',', '.', 2)}</td>
                                    <td style={{ fontSize: "10px", textAlign: "right" }}>{formatMoneda(item.multa.toString().replace('.', ','), ',', '.', 2)}</td>
                                    <td style={{ fontSize: "10px", textAlign: "right" }}>{formatMoneda(item.recargo.toString().replace('.', ','), ',', '.', 2)}</td>
                                </tr>

                            ))
                        }
                    </tbody>

                </TblContainer>
                <div className="col-md-12 border-table mx-auto row px-0" style={{ borderTop: 'none' }} >
                    <div className='col-md-8 row mx-auto'>
                        <div className="row col-md-8 mx-auto my-auto">

                            <div className="col">
                                <label htmlFor="inputRitm" style={{ fontSize: "16px", fontWeight: "bold" }}>Crédito a Favor: </label>
                            </div>
                            <div className="col">
                                <label htmlFor="inputRitm" style={{ fontSize: "16px", textAlign: "right", fontWeight: "bold" }}>{props.credito !== null && props.credito !== undefined ? formatMoneda(props.credito.toString().replace('.', ','), ',', '.', 2) : '0,00'}</label>
                            </div>

                        </div>
                    </div>
                    <div className='col-md-4 row'>

                        <div class="input-group input-group-sm mb-0 col-md-12">
                            <span class="input-group-text bg-transparent border-0" id="inputGroup-sizing-sm">Deuda:</span>
                            <input type="text" value={deuda} class="form-control text-right bg-transparent border-0" aria-label="Sizing example input" aria-describedby="inputGroup-sizing-sm" />
                        </div>

                        <div class="input-group input-group-sm mb-0 col-md-12">
                            <span class="input-group-text bg-transparent border-0" id="inputGroup-sizing-sm">Intereses de Mora:</span>
                            <input type="text" value={interes} class="form-control text-right bg-transparent border-0" aria-label="Sizing example input" aria-describedby="inputGroup-sizing-sm" />
                        </div>

                        <div class="input-group input-group-sm mb-0 col-md-12">
                            <span class="input-group-text bg-transparent border-0" id="inputGroup-sizing-sm">Recargo por Mora:</span>
                            <input type="text" value={recargo} class="form-control text-right bg-transparent border-0" aria-label="Sizing example input" aria-describedby="inputGroup-sizing-sm" />
                        </div>

                        <div class="input-group input-group-sm mb-0 col-md-12">
                            <span class="input-group-text bg-transparent border-0" id="inputGroup-sizing-sm">Multa:</span>
                            <input type="text" value={multa} class="form-control text-right bg-transparent border-0" aria-label="Sizing example input" aria-describedby="inputGroup-sizing-sm" />
                        </div>

                        <div class="input-group input-group-sm mb-0 col-md-12">
                            <span class="input-group-text bg-transparent border-0" id="inputGroup-sizing-sm">Total de la Deuda:</span>
                            <input type="text" value={totDeuda} class="form-control text-right bg-transparent border-0" aria-label="Sizing example input" aria-describedby="inputGroup-sizing-sm" />
                        </div>

                    </div>
                </div>
            </div>
            <Dimmer active={activate} inverted></Dimmer>
        </div>
    );
}
export default TablaDeudaComercio;